/* eslint-disable */
export enum QuotaManager {
	PCRF_MS = 'PCRF_MS',
	OCS_MS = 'OCS_MS',
}
